<template>
  <div>
    404
  </div>
</template>

<script>
export default {
  name: "NotFound",
  watch: {
    $route: {
      handler:function (newVal) {
        console.log(newVal)
        const {name} = newVal
        if(name  === '404') {
          this.$message.error(
              '页面不存在'
          )
          setTimeout(_=> {
            this.$router.go(-1)
          }, 200)
        }
      },
      immediate: true,
      deep: true
    }
  }
}
</script>

<style scoped>

</style>